import { Component,  OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { UserRepository } from '../../user.repository';
import { NotifyService, ToastType } from 'app/notify';

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss']
})

export class EmailVerificationComponent implements OnInit {

  public resetForm: FormGroup;

  constructor(
    private userRepository: UserRepository,
    private formBuilder: FormBuilder,
    private router: Router,
    private translateService: TranslateService,
    private notifyService: NotifyService,
    private notify: NotifyService
  ) { }

  ngOnInit() {
    this.createResetForm();
  }

  public sendEmailVerification({ valid, value }) {
    if (!valid) {
      return;
    }

    this.userRepository.resetPassword(value.email)
    .subscribe(
      () => {
        this.resetForm.reset();
        this.router.navigate(['login']);
        this.notify.toast(ToastType.SUCCESS, this.translateService.instant('user.reset_password.messages.email_success'));
      },
      () => {
        this.resetForm.reset();
        this.notify.toast(ToastType.ERROR, this.translateService.instant('user.reset_password.messages.email_error'));
      }
    );
  }

  private createResetForm(): void {
    this.resetForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

}



// WEBPACK FOOTER //
// /dist/src/app/user/reset-password/email-verification/email-verification.component.ts